import { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";
import { Logo } from "./Logo";
import { CTA_URL } from "../lib/constants";
import { handleAnchor } from "../lib/scroll";

const LINKS = [
    { label: "Why Emergent", href: "#why-emergent", testId: "nav-link-why-emergent" },
    { label: "Compare", href: "#compare", testId: "nav-link-compare" },
    { label: "How it works", href: "#how-it-works", testId: "nav-link-how-it-works" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const { scrollYProgress } = useScroll();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed inset-x-0 top-0 z-40 border-b bg-[#050505]/70 backdrop-blur-xl transition-[border-color] duration-300 ${
                scrolled ? "border-white/10" : "border-transparent"
            }`}
        >
            <motion.div
                className="h-[2px] origin-left bg-gradient-to-r from-[#00C2FF] to-[#8B5CF6]"
                style={{ scaleX: scrollYProgress }}
            />
            <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
                <a
                    href="#"
                    data-testid="nav-logo"
                    onClick={handleAnchor(0)}
                    className="flex items-center gap-2.5"
                    aria-label="RedeemDeals home"
                >
                    <Logo size={24} />
                    <span className="font-display text-lg font-medium tracking-tight text-white">RedeemDeals</span>
                </a>
                <div className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testId}
                            onClick={handleAnchor(l.href)}
                            className="text-sm text-white/60 transition-colors duration-200 hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>
                <a
                    href={CTA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="nav-cta-button"
                    className="rounded-full bg-white px-4 py-2 text-sm font-medium text-black transition-transform duration-200 hover:scale-105 sm:px-5"
                >
                    Start Building Free
                </a>
            </nav>
        </header>
    );
};
